import { useIsFetching, useQueryClient } from "react-query";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, useTheme } from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { useLocations, useModuleInventory } from "../../../intake/intakeQueries";
import { ModuleInventoryTablePage } from "./ModuleInventoryTablePage";
import React, { ChangeEvent, useState } from "react";
import Pagination from "@material-ui/lab/Pagination"; // Make sure to import Pagination
import { useDispositions, useProjectDispositions, useWorkOrderDispositions, useWorkOrderUnitsDispositions } from "../../../common/services/dispositionServices";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import { getTheme } from "../../../common/getLocalTheme";
import CloseIcon from '@material-ui/icons/Close';
import { toast } from "react-toastify";
import { useUpdateEolDisposition } from "../../../dataEgress/dataEgressMutations";

export const ModuleInventoryPage = () => {
  const [page, setPage] = React.useState(1); // State for current page
  const itemsPerPage = 100; // Number of items per page
  const isFetching = useIsFetching();
  const theme = useTheme();
  const queryClient = useQueryClient();
  const history = useHistory();
  const [status, setStatus] = React.useState('all');
  const [serialNumber, setSerialNumber] = React.useState("");
  const [project_number, setProjectNumber] = React.useState('');
  const [customer, setCustomer] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [action, setAction] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [selectedfilter, setFilter] = useState('All modules in inventory');

  const [open, setOpen] = React.useState(false);
  const [startDate, setStartDate] = React.useState('');
  const [checked, setChecked] = React.useState(true);
  const [selectDisposition, setSelectDisposition] = useState<string | null>(null);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const { authAxios } = useFetchContext();
  const [selectedSerialNumber, setSelectedSerialNumber] = React.useState<string[]>([]);

  const {
    data: data,
    error: errorData,
    isLoading: isLoading,
    isError: isErrorData,
  } = useModuleInventory(status == 'all' ? false : true, serialNumber, project_number, customer, location, page == 1 ? 0 : (page - 1) * 100, itemsPerPage, action);



  const {
    error: errorLocations,
    data: locations,
    isLoading: isLoadingLocations,
    isError: isErrorLocations,
  } = useLocations();


  const {
    error: errorDispositions,
    data: dispositions,
    isLoading: isLoadingDispositions,
    isError: isErrorDispositions,
  } = useWorkOrderUnitsDispositions();

  const handleInputChangeSerial = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSerialNumber(event.target.value);
  };
  const handleInputChangeProject = (event: React.ChangeEvent<HTMLInputElement>) => {
    setProjectNumber(event.target.value);
  };

  const handleInputChangeCustomer = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCustomer(event.target.value);
  };

  const handleInputChangeLocation = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocation(event.target.value);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const handleStartDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {

    setStartDate(e.target.value);

  };


  const handleButtonClick = () => {
    if (serialNumber != "") {
      setPage(0)
    } else {
      setPage(1)
    }
    setAction(action + 1)
    queryClient.invalidateQueries(['module_inventory_data']);
  };

  const handleButtonClickClear = () => {
    setPage(1)
    setSerialNumber("")
    setProjectNumber("")
    setCustomer("")
    setLocation("")
    setStatus("all")
    setAction(action + 1)
    queryClient.invalidateQueries(['module_inventory_data']);
  };


  const handleButtonClickLog = () => {
    history.push(`/operations_management/module_inventory/transit_log`);
  };

  const handleButtonOpenDialog = () => {
    setOpen(true);
  };

  const handleButtonCloseDialog = () => {
    setOpen(false);
  };

  const { mutateAsync: mutateUpdateEolDisposition } = useUpdateEolDisposition();
  const handleButtonUpdate = async () => {
    try {

      await mutateUpdateEolDisposition({
        authAxios,
        serialNumber: selectedSerialNumber,
        disposition: selectDisposition,
        date: startDate,
      });
      toast.success("Request Submited Successfully");
      setOpen(false)
      setAction(action + 1)
      queryClient.invalidateQueries(['module_inventory_data']);
      setSelectedSerialNumber([]);
      setStartDate("");

    } catch (error) {
      toast.error("Request Submition Failed");
      setOpen(false)
    }

  };

  const handleDownload = async (event: React.ChangeEvent<{ value: unknown }>) => {
    try {
      setLoading(true); // Set loading state to true
      console.log('Selected value:', event.target.value);

      var selectedOption = '';
      var downloadOption = '';

      if (event.target.value as string == 'download_all') {
        // if(selectedfilter == 'All modules in inventory'){
        //   downloadOption = event.target.value as string;
        //   selectedOption = 'All modules in inventory'
        // }
        // else{
        //   downloadOption = 'download_active';
        //   selectedOption = 'All Active modules in inventory'
        // }
        downloadOption = event.target.value as string;
        selectedOption = 'Download Filtered Data'
      } else if (event.target.value as string == 'download_davis_to_napa') {
        downloadOption = event.target.value as string;

        selectedOption = "Davis to Napa"
      } else {
        downloadOption = event.target.value as string;

        selectedOption = "Napa to Davis"
      }



      // // Fetch the file as a blob
      // const response = await authAxios.get(
      //   urls.units.inventoryDownload(downloadOption),
      //   { responseType: 'blob' }
      // );

      const response = await authAxios.get(downloadOption == 'download_all' ? urls.units.inventoryFilterDownload(status == 'all' ? false : true, serialNumber, project_number, customer, location, page == 1 ? 0 : (page - 1) * 100, itemsPerPage) : urls.units.inventoryDownload(downloadOption),
        { responseType: 'blob' });


      // Create a download URL for the blob data
      const downloadUrl = URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = downloadUrl;



      // Set the download filename with the current timestamp
      a.download = `${selectedOption} ${moment().format('MMM-DD-YYYY-HHMMSS')}.csv`;
      document.body.appendChild(a);
      a.click();

      // Clean up after the download
      URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error during download:', error);
    } finally {
      setLoading(false); // Set loading state back to false
    }
  };



  if (isLoading || isLoadingLocations || isLoadingDispositions || loading) {
    return (
      <Backdrop open={isLoading || isLoadingLocations || isLoadingDispositions || loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (isErrorData) return <>{isErrorData && <ErrorMessage error={isErrorData} />}</>;

  const handleChange = async (e: React.ChangeEvent<{ value: any }>) => {
    setSelectDisposition(e.target.value as string)
  }

  const handleDataFromChild = (data: any) => {
    setSelectedSerialNumber(data);
    console.log('Data received from child:', data);
  };

  return (
    <>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={1}
      >


        <Grid item xs={12} alignItems="center" justifyContent="center">
          <FormControl component="fieldset">
            <FormLabel component="legend">Filter by status</FormLabel>
            <RadioGroup
              row
              aria-label="status"
              name="status"
              value={status}
              onChange={(event, value) => {
                // if(value==="all"){  
                //   setFilter('All modules in inventory')
                // }
                // else if(value==="active"){  
                //   setFilter('All Active modules in inventory')
                // }else{
                //   setFilter('All modules in inventory')
                // }
                setSelectedValue(value);

                console.log('Changing page to:', value);
                setStatus(value)
                setSerialNumber("")
                setProjectNumber("")
                setCustomer("")
                setLocation("")
                setPage(1);
                setAction(action + 1)
                queryClient.invalidateQueries(['module_inventory_data']);
              }}
            >
              <FormControlLabel value="all" control={<Radio />} label="All" />
              <FormControlLabel value="active" control={<Radio />} label="Active" />
            </RadioGroup>
          </FormControl>


          <FormControl variant="outlined" style={{ width: '300px' }}>
            <InputLabel id="download-label">Select option for Download</InputLabel>
            <Select
              labelId="download-label"
              id="download-label"
              disableUnderline
              disabled={getTheme()}
              label="Select option for Download"
              onChange={handleDownload}
            >
              <MenuItem value="download_all">Download Filtered Data</MenuItem>
              <MenuItem value="download_napa_to_davis">Napa to Davis</MenuItem>
              <MenuItem value="download_davis_to_napa">Davis to Napa</MenuItem>

            </Select>
          </FormControl>
          <FormControl style={{ marginLeft: '16px' }}  >
            <TextField
              label="Serial number"
              variant="outlined"
              value={serialNumber}
              onChange={handleInputChangeSerial}
            />
          </FormControl>
          <FormControl style={{ marginLeft: '16px' }}  >
            <TextField
              label="Project Number"
              variant="outlined"
              value={project_number}
              onChange={handleInputChangeProject}
            />
          </FormControl>
          <FormControl style={{ marginLeft: '16px' }}  >
            <TextField
              label="Customer"
              variant="outlined"
              value={customer}
              onChange={handleInputChangeCustomer}
            />
          </FormControl>
          <FormControl style={{ marginLeft: '16px' }}  >
            <TextField
              label="Location"
              variant="outlined"
              value={location}
              onChange={handleInputChangeLocation}
            />
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: '16px', marginTop: '10px' }}
            onClick={handleButtonClick}
          >
            Search
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: '16px', marginTop: '10px' }}
            onClick={handleButtonClickClear}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={getTheme()}
            style={{ marginLeft: '16px', marginTop: '10px' }}
            onClick={handleButtonClickLog}
          >
            Transit Log
          </Button>


            <Button
              variant="contained"
              color="primary"
              disabled={getTheme() || selectedSerialNumber.length===0}
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={handleButtonOpenDialog}
            >
              Update
            </Button>
          
        </Grid>





        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Pagination
              count={Math.ceil(data.count / itemsPerPage)}
              page={page}
              onChange={(event, value) => {
                console.log('Changing page to:', value);
                setPage(value);
                queryClient.invalidateQueries(['module_inventory_data']);
              }}
              variant="outlined"
              color="primary"
            />

            <label style={{ marginLeft: '16px' }}>
              {data.count} results
            </label>
          </div>
        </Grid>

      </Grid>

      <Box padding={1}></Box>
      {data && locations && (
        <>
          {<ModuleInventoryTablePage data={data.results} locations={locations} dispositions={dispositions} serialNumbers={setSelectedSerialNumber} />}
          <Box padding={2}> </Box>
          <Pagination
            count={Math.ceil(data.count / itemsPerPage)}
            page={page}
            onChange={(event, value) => {
              console.log('Changing page to:', value);
              setPage(value);
              queryClient.invalidateQueries(['module_inventory_data']);
            }}
            variant="outlined"
            color="primary"
          />
        </>
      )}


      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={false}>
        <DialogTitle id="id">
          <div>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1} >{"Update Project Info"}</Box>
              <Box>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </div>
        </DialogTitle>
        <DialogContent>
          <Divider variant="fullWidth" />


          <FormControl style={{ marginLeft: '16px', marginTop: 16 }}  >
            <TextField
              id="start-date"
              label="Start Date"
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              InputLabelProps={{
                shrink: true, // Keeps the label visible when a value is selected
              }}
              variant="outlined" // Adds an outline to the input
            />
          </FormControl>

          <FormControl variant="outlined" style={{ width: '200px', marginLeft: 16, marginTop: 16 }}>
            <InputLabel id="download-label">EOL Disposition</InputLabel>
            <Select
              labelId="download-label"
              id="download-label"
              disableUnderline
              label="eol disposition"
              onChange={handleChange}
            >
              {dispositions?.map((disposition: any) => (
                <MenuItem key={disposition.id}
                  value={disposition.id}>
                  {disposition.name}
                </MenuItem>
              ))}

            </Select>
          </FormControl>

          <Grid style={{ marginTop: 15 }}>


            <Button
              variant="contained"
              color="primary"
              disabled={getTheme()}
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={handleButtonUpdate}
            >
              Update
            </Button>


            <Button
              variant="contained"
              color="primary"
              disabled={getTheme()}
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={handleButtonCloseDialog}
            >
              Cancel
            </Button>

          </Grid>


        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>

    </>
  );
};
